import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "lb" }
const _hoisted_2 = { class: "lb__card" }
const _hoisted_3 = { class: "lb__your-rank" }
const _hoisted_4 = { class: "lb__your-rank-main" }
const _hoisted_5 = { class: "lb__your-rank-value" }
const _hoisted_6 = { class: "lb__your-rank-meta" }
const _hoisted_7 = { class: "lb__your-xp" }
const _hoisted_8 = {
  key: 0,
  class: "lb__your-streak",
  title: "روز متوالی"
}
const _hoisted_9 = {
  key: 0,
  class: "lb__podium"
}
const _hoisted_10 = {
  class: "lb__medal-svg",
  viewBox: "0 0 56 64",
  fill: "none",
  "aria-hidden": "true"
}
const _hoisted_11 = ["id"]
const _hoisted_12 = ["stop-color"]
const _hoisted_13 = ["stop-color"]
const _hoisted_14 = ["stop-color"]
const _hoisted_15 = ["fill"]
const _hoisted_16 = ["fill"]
const _hoisted_17 = ["fill"]
const _hoisted_18 = ["fill"]
const _hoisted_19 = ["fill"]
const _hoisted_20 = {
  x: "28",
  y: "38.5",
  "text-anchor": "middle",
  class: "lb__medal-label"
}
const _hoisted_21 = { class: "lb__podium-name" }
const _hoisted_22 = {
  key: 0,
  class: "lb__podium-streak"
}
const _hoisted_23 = {
  key: 1,
  class: "lb__list"
}
const _hoisted_24 = { class: "lb__row-rank" }
const _hoisted_25 = { class: "lb__row-name" }
const _hoisted_26 = {
  key: 0,
  class: "lb__row-streak",
  title: "روز متوالی"
}
const _hoisted_27 = { class: "lb__row-xp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("header", { class: "lb__header" }, [
        _createElementVNode("i", {
          class: "bi bi-trophy-fill lb__header-icon",
          "aria-hidden": "true"
        }),
        _createElementVNode("div", null, [
          _createElementVNode("h2", { class: "lb__title" }, "جدول امتیازات"),
          _createElementVNode("p", { class: "lb__subtitle" }, "هفتگی · XP")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "lb__your-rank-label" }, "رتبه شما", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString($options.yourRankLabel), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString($data.yourXp) + " XP", 1),
          ($data.yourStreak > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _cache[1] || (_cache[1] = _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  width: "12",
                  height: "12",
                  fill: "currentColor",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", { d: "M12 2s4 4.2 4 8a4 4 0 1 1-8 0c0-2.4 1.4-4.6 2.6-6.2.4-.5 1.4.1 1.2.8C11.4 6.2 12 8 12 9c0-3-1.5-5.5-3-7 3 1 5 4 5 7a5 5 0 1 1-10 0c0-3.5 2.5-6.5 5-9z" })
                ], -1)),
                _createTextVNode(" " + _toDisplayString($data.yourStreak), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      ($data.loading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, {
            key: 0,
            message: "در حال بارگذاری..."
          }))
        : ($data.errorMessage)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 1,
              message: $data.errorMessage,
              onRetry: $options.load
            }, null, 8, ["message", "onRetry"]))
          : (!$options.displayRows.length)
            ? (_openBlock(), _createBlock(_component_EmptyState, {
                key: 2,
                title: "هنوز امتیازی ثبت نشده",
                message: "با تکمیل آزمون، XP هفتگی‌ات اینجا دیده می‌شود."
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                ($options.podiumOrder.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.podiumOrder, (entry) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: entry.user_id + '-' + entry.rank,
                          class: _normalizeClass(["lb__podium-card", `lb__podium-card--rank-${entry.rank}`])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["lb__medal", `lb__medal--rank-${entry.rank}`])
                          }, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                              _createElementVNode("defs", null, [
                                _createElementVNode("linearGradient", {
                                  id: `medal-gradient-${entry.rank}`,
                                  x1: "8",
                                  y1: "4",
                                  x2: "48",
                                  y2: "60",
                                  gradientUnits: "userSpaceOnUse"
                                }, [
                                  _createElementVNode("stop", {
                                    offset: "0%",
                                    "stop-color": $options.medalGradient(entry.rank).start
                                  }, null, 8, _hoisted_12),
                                  _createElementVNode("stop", {
                                    offset: "55%",
                                    "stop-color": $options.medalGradient(entry.rank).mid
                                  }, null, 8, _hoisted_13),
                                  _createElementVNode("stop", {
                                    offset: "100%",
                                    "stop-color": $options.medalGradient(entry.rank).end
                                  }, null, 8, _hoisted_14)
                                ], 8, _hoisted_11)
                              ]),
                              _createElementVNode("path", {
                                fill: `url(#medal-gradient-${entry.rank})`,
                                d: "M20.2 8.2C14.8 9.8 12.2 15.8 14.2 21.6C15.2 24.4 17.6 25.8 19.8 24.8L20.8 21.2C19.2 18.6 18.8 14.2 20.8 10.8C20.6 9.8 20.4 9 20.2 8.2Z"
                              }, null, 8, _hoisted_15),
                              _createElementVNode("path", {
                                fill: `url(#medal-gradient-${entry.rank})`,
                                d: "M35.8 8.2C41.2 9.8 43.8 15.8 41.8 21.6C40.8 24.4 38.4 25.8 36.2 24.8L35.2 21.2C36.8 18.6 37.2 14.2 35.2 10.8C35.4 9.8 35.6 9 35.8 8.2Z"
                              }, null, 8, _hoisted_16),
                              _createElementVNode("circle", {
                                cx: "28",
                                cy: "33",
                                r: "16",
                                fill: `url(#medal-gradient-${entry.rank})`
                              }, null, 8, _hoisted_17),
                              _createElementVNode("rect", {
                                x: "25",
                                y: "48",
                                width: "6",
                                height: "5.5",
                                rx: "1.5",
                                fill: `url(#medal-gradient-${entry.rank})`
                              }, null, 8, _hoisted_18),
                              _createElementVNode("rect", {
                                x: "18.5",
                                y: "53.5",
                                width: "19",
                                height: "5",
                                rx: "2.5",
                                fill: `url(#medal-gradient-${entry.rank})`
                              }, null, 8, _hoisted_19),
                              _createElementVNode("text", _hoisted_20, _toDisplayString(entry.rank), 1)
                            ]))
                          ], 2),
                          _createElementVNode("p", _hoisted_21, _toDisplayString(entry.name), 1),
                          _createElementVNode("p", {
                            class: _normalizeClass(["lb__podium-score", { 'lb__podium-score--gold': entry.rank === 1 }])
                          }, _toDisplayString(entry.score) + " XP ", 3),
                          (entry.streak > 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(entry.streak) + " روز متوالی ", 1))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                ($options.listRows.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.listRows, (row) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: row.user_id + '-' + row.rank,
                          class: _normalizeClass(["lb__row", { 'lb__row--me': row.isMe }])
                        }, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(row.rank), 1),
                          _createElementVNode("div", {
                            class: "lb__avatar",
                            style: _normalizeStyle({ background: $options.avatarStyle(row).bg, color: $options.avatarStyle(row).color })
                          }, _toDisplayString($options.initials(row.name)), 5),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(row.name), 1),
                          (row.streak > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                _cache[2] || (_cache[2] = _createElementVNode("svg", {
                                  viewBox: "0 0 24 24",
                                  width: "11",
                                  height: "11",
                                  fill: "currentColor",
                                  "aria-hidden": "true"
                                }, [
                                  _createElementVNode("path", { d: "M12 2s4 4.2 4 8a4 4 0 1 1-8 0c0-2.4 1.4-4.6 2.6-6.2.4-.5 1.4.1 1.2.8C11.4 6.2 12 8 12 9c0-3-1.5-5.5-3-7 3 1 5 4 5 7a5 5 0 1 1-10 0c0-3.5 2.5-6.5 5-9z" })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(row.streak), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(row.score) + " XP", 1)
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _cache[3] || (_cache[3] = _createElementVNode("button", {
                  type: "button",
                  class: "lb__footer-btn",
                  disabled: ""
                }, [
                  _createElementVNode("i", {
                    class: "bi bi-trophy",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" مشاهده جدول کامل ")
                ], -1))
              ], 64))
    ])
  ]))
}